import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { Phone, ArrowRight } from "lucide-react";
import { CONTACT } from "../../data/site";

// Mobile-only sticky CTA. Appears after scrolling; hidden on the intake page.
export default function StickyCTA() {
  const { pathname } = useLocation();
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 360);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  if (pathname === "/get-started") return null;

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ y: 90, opacity: 0 }} animate={{ y: 0, opacity: 1 }} exit={{ y: 90, opacity: 0 }}
          transition={{ duration: 0.3, ease: [0.16, 1, 0.3, 1] }}
          className="fixed inset-x-0 bottom-0 z-40 border-t border-white/10 bg-black/85 px-4 pb-[max(0.75rem,env(safe-area-inset-bottom))] pt-3 backdrop-blur-xl lg:hidden"
          data-testid="sticky-cta"
        >
          <div className="flex items-center gap-2.5">
            <a href={CONTACT.phoneHref} aria-label={`Call ${CONTACT.phone}`}
              className="grid h-12 w-12 shrink-0 place-items-center rounded-full border border-gold-500/50 text-gold-400 transition active:scale-95"
              data-testid="sticky-call">
              <Phone size={20} />
            </a>
            <Link to="/get-started"
              className="flex flex-1 items-center justify-center gap-2 rounded-full bg-gold-500 py-3.5 font-semibold text-black transition active:scale-[0.99]"
              data-testid="sticky-get-started">
              Let's Get Started <span className="text-black/60">· from $999</span> <ArrowRight size={16} />
            </Link>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
